import { SearchResultItem } from '@smart-tv/typings/search';

import { kmm } from './kmm';
import { mapSearchResultItem } from './search-helpers';

export async function getSearchHistory(startIndex: number, itemLimit: number): Promise<SearchResultItem[]> {
  const history = await kmm((repo) => repo.getSearchHistory(startIndex, itemLimit));

  return history.asJsReadonlyArrayView().map(mapSearchResultItem);
}

export default getSearchHistory;
